import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram } from "lucide-react";
import { Input } from "@mui/joy";
import { Button } from "@mui/joy";
import React from "react";
export default function Footer() {
  return (
    <footer className="bg-indigo-900 text-white py-12">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="text-lg font-semibold mb-4">ProAstrologyReport</h3>
          <p className="text-sm text-indigo-200">
            Illuminating your path with cosmic wisdom.
          </p>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2">
            <li>
              <Link to="#" className="text-sm text-indigo-200 hover:text-white">
                Home
              </Link>
            </li>
            <li>
              <Link to="#" className="text-sm text-indigo-200 hover:text-white">
                Horoscopes
              </Link>
            </li>
            <li>
              <Link to="#" className="text-sm text-indigo-200 hover:text-white">
                Numerology
              </Link>
            </li>
            <li>
              <Link to="#" className="text-sm text-indigo-200 hover:text-white">
                About Us
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4">Connect With Us</h4>
          <div className="flex space-x-4">
            <Link to="#" aria-label="Facebook">
              <Facebook className="w-6 h-6 text-indigo-200 hover:text-white" />
            </Link>
            <Link to="#" aria-label="Twitter">
              <Twitter className="w-6 h-6 text-indigo-200 hover:text-white" />
            </Link>
            <Link to="#" aria-label="Instagram">
              <Instagram className="w-6 h-6 text-indigo-200 hover:text-white" />
            </Link>
          </div>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4">Get Cosmic Updates</h4>
          <form className="flex">
            <Input
              type="email"
              placeholder="Your email"
              className="rounded-r-none"
            />
            <Button type="submit" className="rounded-l-none">
              Subscribe
            </Button>
          </form>
        </div>
      </div>
      <div className="container mx-auto mt-8 pt-8 border-t border-indigo-800 text-center text-sm text-indigo-200">
        © {new Date().getFullYear()} ProAstrologyReport. All rights reserved.
      </div>
    </footer>
  );
}
